/* @flow */
import * as React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { RequestInAppBlock, ReviewBlock, ThreeFeaturesBlock } from '../components';
import { BodyText, Container, SectionTitle, Spacer } from '../../components/core';
import Colors from '../../constants/Colors';
import { PageBody } from '../../components/chrome';
import { ResponsiveEstimateForm } from '../../components/EstimateForm';
import Reviews, { getReviewTagged } from '../../../data/Reviews';
import type { ServicesPageChromeMetadata } from './ServicesPageChrome';
import tripRequests from '../../../redux/trip-requests';
import type { UseCase } from '../../../data/TripRequests';

class CraigslistDeliveryPage extends React.Component<{
  setNewTripRequestUseCase: (useCase: UseCase) => void,
}> {
  static metadata = {
    title: 'Craigslist Delivery',
    description:
      'Craigslist furniture delivery in as little as 30 minutes. Order on-demand movers to pickup and deliver furniture for you on craigslist.',
  };

  static servicesMetadata: ServicesPageChromeMetadata = {
    illustration: 'craigslist-purchase',
    id: 'craigslist-delivery',
    useCase: 'p2p',
  };

  componentDidMount() {
    const { setNewTripRequestUseCase } = this.props;
    setNewTripRequestUseCase('p2p');
  }

  render() {
    return (
      <PageBody>
        <Container padded={true}>
          <SectionTitle title="Craigslist pick up and delivery" />
          <BodyText
            size="16"
            align="center"
            style={{ maxWidth: '630px', marginLeft: 'auto', marginRight: 'auto' }}>
            Shop used, buy local. It’s never been easier to buy on services like Craigslist, Offerup
            & Letgo. Pay online and let Lugg pick it up and deliver into your home.
          </BodyText>
          <Spacer size={80} />
          <ThreeFeaturesBlock
            features={[
              {
                title: 'Anything, anywhere',
                description:
                  'We’ll go the distance to pick up that item you love. We deliver up to 150 miles outside our service area.',
                icon: 'map',
              },
              {
                title: 'Pay the seller',
                description:
                  'No more runs to the ATM. Pay for your items using services like Venmo or Square Cash prior to pickup.',
                icon: 'pay-online',
              },
              {
                title: 'Delivered into your home',
                description:
                  'Just let the seller know that Lugg will pick up your purchase for you. You don’t even have to leave the house.',
                icon: 'stay-at-home',
              },
            ]}
          />
        </Container>
        <Spacer size={120} />
        <Container size="large" padded={true}>
          <ResponsiveEstimateForm />
        </Container>
        <Spacer size={120} />
        <Container padded={true} align="center">
          <RequestInAppBlock />
        </Container>
        <Container size="large" padded={true}>
          <Spacer size={200} color={Colors.Divider} />
        </Container>
        <Container padded={true}>
          <ReviewBlock review={getReviewTagged(Reviews, 'craigslist-page')} />
        </Container>
      </PageBody>
    );
  }
}

export default compose(
  connect(
    null,
    dispatch => ({
      setNewTripRequestUseCase: useCase =>
        dispatch(tripRequests.actions.setNewTripRequestUseCase(useCase)),
    })
  )
)(CraigslistDeliveryPage);



// WEBPACK FOOTER //
// ./src/ui/pages/ServicesPage/CraigslistDeliveryPage.js